import { RefObject } from 'react';

export const usePortalClick = (ref: RefObject<HTMLElement>) => {
  const isPortalClick = (e: React.MouseEvent) => {
    return !ref.current?.contains(e.target as Node);
  };

  return { isPortalClick };
}; 